module.exports = __webpack_public_path__ + "img/background.f75ec2bb.png";